import {Component, OnInit} from "@angular/core";
import {IVersionDetails} from "../../versiont.details/interfaces/version.details";
import {VersionDetailsService} from "../../versiont.details/services/version.details.service";
import {ProductLabelingState} from "../../versiont.details/interfaces/product.labeling.state";

@Component({
  selector: 'app-terms-page',
  templateUrl: './terms.page.template.html',
  styleUrls: ['./terms.page.style.scss']
})
export class TermsPageComponent implements OnInit {

  public buildDate: string;
  public readonly copyrightYear = 2025;
  public releaseVersion: string;
  public isUnreleasedDevice: boolean;
  public isNonMedicalDevice: boolean;



  constructor(private versionDetailsService: VersionDetailsService) {
  }


  ngOnInit(): void {
    const versionDetails: IVersionDetails =  this.versionDetailsService.getVersionDetails();

    this.buildDate =   this.getFormattedBuildDate(versionDetails.buildDate);
    this.releaseVersion = this.getProductReleaseVersion(versionDetails.commercialVersion);
    this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
    this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
  }

  private getFormattedBuildDate(buildDate: Date): string {
    return buildDate.getFullYear() + "-"
      +  this.padDatePart(buildDate.getMonth() + 1) + "-"
      + this.padDatePart(buildDate.getDate());
  }
  private padDatePart(datePart: number) {

    const datePartStr = datePart.toString();
    if (datePartStr.length === 1) {
      return "0" + datePartStr;
    }
    return datePartStr;
  }

  private getProductReleaseVersion(commercialVersion: string): string {
    const versionParts : string[] = commercialVersion.split('.');
    if (versionParts.length > 1){
      return `${versionParts[0]}.${versionParts[1]}`;
    }
    return commercialVersion;
  }

}
